import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {createSelector} from 'reselect'
import {RamblerIcon} from 'rambler-ui'
import {selectDefaultChampionat} from 'models/user/selectors'
import styles from './styles.css'

function HeadProfiles({defaultChampionat}) {
  return (
    <article className={styles.root}>
      <div className={styles.logo}>
        <RamblerIcon size={15} />
      </div>
      <div className={styles.profiles}>
        <span>Мои аккаунты:</span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://lenta.ru/my/dashboard">
          Lenta.ru
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.afisha.ru/personalpage">
          Афиша
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://www.championat.com/${
            defaultChampionat ? `user/${defaultChampionat}` : ''
          }`}>
          Чемпионат
        </a>
        <a target="_blank" rel="noopener noreferrer" href="https://eda.ru">
          Eda.ru
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://mail.rambler.ru">
          Рамблер/почта
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://stat.top100.rambler.ru">
          Рамблер/топ-100
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://dating.rambler.ru/a-myprofile">
          Рамблер/знакомства
        </a>
      </div>
    </article>
  )
}

HeadProfiles.propTypes = {
  defaultChampionat: PropTypes.string
}

const mapStateToProps = createSelector(
  selectDefaultChampionat,
  (defaultChampionat) => ({
    defaultChampionat
  })
)

export default connect(mapStateToProps)(HeadProfiles)
